import { SFFProblemType } from './page-data';

export enum ProblemStage {
  /** Only used for evaluation type questions */
  ReadTranscript = 'Read Transcript',
  /** Student at first attempt at picking/entering their answer */
  CollectInput = 'Collect Input',
  /** Only used for evaluation type questions */
  Evaluate = 'Evaluate',
  /** Student got first attempt wrong, picking/entering answers for second time */
  SecondTry = 'Second Try',
  /** No more submissions allowed, student got the question correct or ran out of attempts */
  ShowResult = 'Show Result'
}

export const problemStageValue = (ps: ProblemStage) =>
  Object.values(ProblemStage).indexOf(ps);

export const initialStage = (pageType: SFFProblemType): ProblemStage => {
  switch (pageType) {

    case SFFProblemType.PeerEval:
    case SFFProblemType.SelfEval: {
      return ProblemStage.ReadTranscript;
    }
    default: {
      return ProblemStage.CollectInput;
    }
      
  }
}